import { Container } from '@lideralia/alife-uikit';
import { EditorGeneratingCard } from '@lideralia/alife-uikit/dist/organisms/BiographicalEditor/EditorGeneratingCard';
import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getActualLanguage } from '../../../../common/functions/lang';
import { pollStatus } from '../../actions';
import { MEMORY_STATUS } from '../../config';

const POLL_INTERVAL_MS = 3000;

export const GeneratingScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { idLine, idName } = useParams();
  const lang = getActualLanguage();

  const intl = useIntl();

  const { memory } = useSelector((state) => state.biographicalEditor);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!memory?.uuid) return () => {};

    intervalRef.current = setInterval(() => {
      dispatch(pollStatus(idLine, memory.uuid));
    }, POLL_INTERVAL_MS);

    return () => clearInterval(intervalRef.current);
  }, [memory?.uuid, dispatch]);

  useEffect(() => {
    if (memory?.status === MEMORY_STATUS.COMPLETED) {
      clearInterval(intervalRef.current);
      history.push(`/${lang}/lines/${idLine}/${idName}/biographical-editor/result`);
    } else if (memory?.status === MEMORY_STATUS.READY || memory?.status === MEMORY_STATUS.DRAFT) {
      clearInterval(intervalRef.current);
      history.push(`/${lang}/lines/${idLine}/${idName}/biographical-editor/blocks`);
    }
  }, [memory?.status]);

  return (
    <Container paddingY={5} maxWidth={['400px']}>
        <EditorGeneratingCard
        title={intl.formatMessage({ id: 'biographicalEditor.generating.title' })}
        subtitle={intl.formatMessage({ id: 'biographicalEditor.generating.subtitle' })}
        statusLabel={intl.formatMessage({ id: 'biographicalEditor.generating.statusLabel' })}
        />
    </Container>
  );
};

export default GeneratingScreen;
